import renderCustomAlert from "../../components/customAlert/customAlert";
import { AppText } from "../../components/multiLanguage/multiLanguage";


export function somethingWentWrongAlert(language){
    renderCustomAlert({
        id: 'something_went_wrong',
        title:AppText.alert.something_went_wrong[language],
        bodyText: AppText.alert.try_again[language],
        type: 'error',
        language: language,
        duration: 2000
    });
}
export function pathNotFoundAlert(language){
    renderCustomAlert({
        id: 'path_not_found',
        title:AppText.alert.path_not_found[language],
        bodyText: AppText.alert.try_again[language],
        type: 'error',
        language: language,
        duration: 2000
    });
}

export function userHasNoReservationAlert(language){
    renderCustomAlert({
        id: 'user_has_no_reservation',
        title:AppText.alert.user_has_no_reservation[language],
        bodyText: AppText.alert.try_again[language],
        type: 'error',
        language: language,
        duration: 2000
    });
}
export function cartIsOfflineAlert(language){
    renderCustomAlert({
        id: 'cart_is_offline',
        title:AppText.alert.cart_is_offline[language],
        bodyText: AppText.alert.try_again[language],
        type: 'error',
        language: language,
        duration: 2000
    });
}
export function userInUseAlert(language){
    renderCustomAlert({
        id: 'user_in_use',
        title:AppText.alert.user_in_use[language],
        bodyText: AppText.alert.try_again[language],
        type: 'error',
        language: language,
        duration: 2000
    });
}
export function cartInPointAlert(language){
    renderCustomAlert({
        id: 'choose_new_destination',
        title: AppText.alert.already_in_point[language],
        bodyText: AppText.alert.choose_new_destination[language],
        type: 'info',
        language: language,
        duration: 2000
    });
}


export function cartNotFoundAlert(language){
    renderCustomAlert({
        id: 'cart_not_found',
        title: AppText.alert.we_sorry[language],
        bodyText: AppText.alert.cart_not_found[language],
        type: 'info',
        language: language,
        duration: 2000
    });
}
